// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";

import ListingGrid from "../../../common/ListingGrid";

import type { $ListingWidgets } from "flow/types";

type Props = {
  favorites: Object,
  listingWidgets: $ListingWidgets,
  widgetInfo: Array<Object>,
};

const ListingGridSpecial = ({
  favorites,
  listingWidgets,
  widgetInfo,
}: Props) => {
  return (
    <div>
      {widgetInfo &&
        widgetInfo.map((widget, i) => {
          return (
            <div key={widget.title}>
              <ListingGrid
                listings={listingWidgets && listingWidgets[i].listings}
                title={widget.title}
                style={{
                  padding: i === widgetInfo.length - 1 ? "48px 0" : "48px 0 0",
                  margin: "0 auto",
                }}
                favorites={favorites}
              />
            </div>
          );
        })}
    </div>
  );
};

export default withGlobalContext(ListingGridSpecial);
